import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ContentSectionComponent } from '../content-section/content-section.component';

@Component({
    selector: 'tran-quote-section',
    templateUrl: './quote-section.component.html',
    imports: [ContentSectionComponent, TranslatePipe, NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteSectionComponent extends ContentSectionComponent {
    public readonly image = input<string>();
    public readonly imageAlt = input<string>('');
    public readonly imagePosition = input<'left' | 'right'>('left');
    public readonly quote = input<string>();
    public readonly author = input<string>();
}
